module.exports = __webpack_public_path__ + "static/media/43-3.8faec921.mp3";